import { CORS } from 'root/utils/cors/cors';
import { Serialize } from 'root/utils/serialize/serialize';

export default function JSTwigLoader(filename, theme, wCredentials, param = {}) {
    this.ENDPOINT = '/rest/twig/load';
    this.METHOD = 'GET';
    this.filename = filename;
    this.theme = theme;
    this.wCredentials = wCredentials;
    this.objectParam = param;
    this.successClb = null;
    this.errorClb = null;
    this.response = null;
}
JSTwigLoader.prototype = {
    getFile() {
        var data = this.getParam();
        CORS.xdr(
            this.ENDPOINT + data,
            this.METHOD,
            '',
            this.successClb,
            this.errorClb,
            this.wCredentials
        );
        return this;
    },

    /**
     * Overrides the default function
     * @param callable callback
     */
    onSuccess(callback) {
        this.successClb = callback;
        return this;
    },

    /**
     * Overrides the default function
     * @param callable callback
     */
    onError(callback) {
        this.errorClb = callback;
        return this;
    },

    getResponse() {
        return this.response;
    },

    getParam() {
        const baseParamObj = {
            file: this.filename,
            theme: this.theme,
        };

        const paramObj = Object.assign(baseParamObj, this.objectParam);
        return `?${Serialize(paramObj)}`;
    },
};
